export default {
  LOAD_LIST_ADDRESS_TYPE(state, data) {
    state.listProtocolType = data
  },
  PREPARE_TO_EDIT(state, data) {
    state.protocolType = data
  },
}
